import React from 'react';
import { SpeciesOverlayVariant } from '../../lib/types';

interface SpeciesOverlayToggleProps {
  variant: SpeciesOverlayVariant;
  onChange: (variant: SpeciesOverlayVariant) => void;
}

// Two-button segmented toggle for swapping between the dominant-species and
// richness species overlays. Positioning is handled by the parent container
// in DetailMapView (grouped with SpeciesMapLegend in a single flex stack) so
// the toggle always sits above the legend regardless of legend height.
export const SpeciesOverlayToggle: React.FC<SpeciesOverlayToggleProps> = ({
  variant,
  onChange,
}) => {
  const tabClass = (active: boolean) =>
    `px-3 py-1.5 text-[11px] font-roboto font-semibold tracking-wide uppercase transition-colors ${
      active
        ? 'bg-figma-mint text-[#070807]'
        : 'text-figma-text hover:bg-figma-mint/10'
    }`;

  return (
    <div
      role="tablist"
      aria-label="Species overlay variant"
      className="inline-flex bg-figma-card/90 border border-figma-mint rounded-[10px] overflow-hidden shadow-figma-card backdrop-blur-sm"
    >
      <button
        role="tab"
        aria-selected={variant === 'dominant'}
        onClick={() => onChange('dominant')}
        className={tabClass(variant === 'dominant')}
      >
        Dominant
      </button>
      <button
        role="tab"
        aria-selected={variant === 'richness'}
        onClick={() => onChange('richness')}
        className={`${tabClass(variant === 'richness')} border-l border-figma-mint/40`}
      >
        Richness
      </button>
    </div>
  );
};
